import { Button } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";

export default function CallBtnComponent() {
  return (
    <Button
      variant="contained"
      href="tel:+959969119949"
      startIcon={<PhoneIcon />}
      sx={{
        mt: 3,
        textTransform: "none",
        borderRadius: 2,
        fontWeight: 600,
      }}
    >
      Start By Saying Hi
    </Button>
  );
}
